import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_CORE_URL,
	withCredentials: true, // Para enviar cookies automáticamente con cada solicitud
});

const apiUpload = axios.create({
	baseURL: process.env.REACT_APP_UPLOAD_URL,
	withCredentials: true, // Para enviar cookies automáticamente con cada solicitud
});

// Función para realizar una solicitud GET a un endpoint específico
export const obtenerDatos = async (endpoint) => {
	try {
		const respuesta = await api.get(endpoint);
		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

// Función para abrir un WebSocket
export const crearWebSocket = (
	endpoint,
	{ onMessage = () => {}, onOpen = () => {}, onError = () => {}, onClose = () => {} } = {}
) => {
	const token = sessionStorage.getItem("access_token");
	const wsUrl = `${process.env.REACT_APP_CORE_URL.replace(/^http/, "ws")}${endpoint}`;
	const ws = new WebSocket(wsUrl, token);

	ws.onopen = (e) => {
		onOpen(e);
	};
	ws.onmessage = (e) => {
		onMessage(JSON.parse(e.data));
	};
	ws.onerror = (e) => {
		console.error("WS error:", e);
		onError(e);
	};
	ws.onclose = (e) => {
		console.warn("WS cerrado:", e);
		onClose(e);
	};
	return ws;
};

export const obtenerDatosSites = async (endpoint) => {
	try {
		const respuesta = await api.post(endpoint);

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

export const obtenerDatosPost = async (site_id, valores) => {
	try {
		const respuesta = await api.post(`/outputs/get_output_data?site_id=${site_id}`, valores);

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};
export const obtenerDatosPostDash = async (site_id, valores) => {
	try {
		// Realizar la solicitud POST con el array de valores como datos
		const respuesta = await api.post(`/outputs/get_output?site_id=${site_id}`, valores);
		// Retornar la data de la respuesta
		return respuesta.data;
	} catch (error) {
		// Manejar errores
		throw error;
	}
};
export const auditPost = async (idModule, site_id) => {
	try {
		const respuesta = await api.post(
			`/auditoria/audit?id_permission_modules=${idModule}&site_id=${site_id}`
		);

		return respuesta.data;
	} catch (error) {
		console.error("Error en auditPost:", error);
		throw error;
	}
};

// Función para realizar una solicitud POST a un endpoint específico
export const agregarDato = async (endpoint, nuevoDato) => {
	try {
		const respuesta = await api.post(endpoint, nuevoDato);
		return respuesta.data;
	} catch (error) {
		console.error("Error in agregarDato:", error);
		throw error;
	}
};
// Función para realizar una solicitud PUT a un endpoint específico
export const actualizarDato = async (endpoint, datosActualizados) => {
	try {
		const respuesta = await api.patch(endpoint, datosActualizados);

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

export const actualizarDatoReview = async (endpoint) => {
	try {
		const respuesta = await api.patch(endpoint);

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

// Función para realizar una solicitud DELETE a un endpoint específico
export const eliminarDato = async (endpoint, id, site_id) => {
	try {
		const respuesta = await api.delete(`${endpoint}/${id}?site_id=${site_id}`);

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

export const obtenerForecast = async (endpoint) => {
	try {
		const headers = {
			"Content-Type": "application/json",
			Accept: "application/json",
		};

		const respuesta = await api.request({
			url: endpoint,
			method: "POST",
			responseType: "arraybuffer",
			headers: headers,
			data: {},
			mode: "cors",
		});

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

export const obtenerStoresConfig = async (endpoint, data) => {
	try {
		const headers = {
			"Content-Type": "application/json",
			Accept: "application/json",
		};

		const respuesta = await api.request({
			url: endpoint,
			method: "POST",
			responseType: "arraybuffer",
			headers: headers,
			data: data,
			mode: "cors",
		});

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

export const obtenerParams = async (endpoint, data) => {
	try {
		const headers = {
			"Content-Type": "application/json",
			Accept: "application/json",
		};

		const respuesta = await api.request({
			url: endpoint,
			method: "GET",
			responseType: "arraybuffer",
			headers: headers,
			data: data,
			mode: "cors",
		});

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};
//funcion para subir archivos excell a la api de upload
export const uploadFile = async (endpoint, file) => {
	try {
		const formData = new FormData();
		formData.append("file", file);
		const respuesta = await apiUpload.post(endpoint, formData);
		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

export const uploadFileSimulation = async (endpoint, data, file) => {
	try {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("input", JSON.stringify(data));

		const respuesta = await api.post(endpoint, formData);

		return respuesta.data;
	} catch (error) {
		throw error;
	}
};
export const descargarAprobados = async () => {
	try {
		const resp = await api.get("/outputs/get_all_approved_outputs_file", {
			responseType: "arraybuffer", // arraybuffer para poder “olfatear” bytes
		});
		return resp;
	} catch (error) {
		throw error;
	}
};
